"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapRootElement = wrapRootElement;

var _react = _interopRequireDefault(require("react"));

var _trustpilotContext = _interopRequireDefault(require("./context/trustpilot-context"));

function wrapRootElement({
  element
}, pluginOptions) {
  return /*#__PURE__*/_react.default.createElement(_trustpilotContext.default.Provider, {
    value: pluginOptions
  }, element);
}